import React from 'react';
import { Star } from 'lucide-react';
import './Testimonials.css';

const Testimonials = () => {
  const testimonials = [
    {
      name: 'Familie Müller',
      event: 'Hochzeit',
      rating: 5,
      text: 'Unsere Hochzeit war ein absoluter Traum! Die Location ist wunderschön und das Team hat uns bei der Planung perfekt unterstützt. Alle Gäste waren begeistert.'
    },
    {
      name: 'Michael Schmidt',
      event: 'Firmenfeier',
      rating: 5,
      text: 'Professionelle Organisation und erstklassiger Service. Die Technik war top und unsere 200 Mitarbeiter hatten einen unvergesslichen Abend.'
    },
    {
      name: 'Sarah Weber',
      event: '50. Geburtstag',
      rating: 5,
      text: 'Von der ersten Anfrage bis zum Event-Tag – alles perfekt! Die Location bietet so viel Platz und die Atmosphäre ist einfach einzigartig.'
    }
  ];

  return (
    <section className="testimonials section-padding">
      <div className="container">
        <div className="testimonials-header">
          <h2 className="heading-1 text-center">
            Das sagen unsere Kunden
          </h2>
        </div>

        <div className="testimonials-grid space-top-xxl">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="testimonial-card">
              <div className="testimonial-rating">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} size={16} fill="currentColor" />
                ))}
              </div>
              <p className="testimonial-text body-regular space-top-md">
                „{testimonial.text}“
              </p>
              <div className="testimonial-author space-top-md">
                <p className="author-name">{testimonial.name}</p>
                <p className="author-event body-small">{testimonial.event}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;